module.exports = __webpack_public_path__ + "static/media/huge-jobsite.208245d8.jpg";